import { render, staticRenderFns } from "./PacmanLoader.htm?vue&type=template&id=7d189c78&scoped=true&"
import script from "./PacmanLoader.js?vue&type=script&lang=js&"
export * from "./PacmanLoader.js?vue&type=script&lang=js&"
import style0 from "./PacmanLoader.scss?vue&type=style&index=0&id=7d189c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d189c78",
  null
  
)

export default component.exports